module.exports = __webpack_public_path__ + "img/logo_hepn.3ca021b1.png";